import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RESET_PASSWORD_REQUEST } from '../../Utils/Constant';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const ResetPassword = ({ onBackToLogin, email, otp }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector(state => state.auth);

  const [formData, setFormData] = useState({
    email: email || '',
    password: '',
    confirmPassword: '',
  });

  const [localError, setLocalError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const emailRef = useRef(null);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setLocalError('Passwords do not match');
      return;
    }

    setLocalError('');
    dispatch({
      type: RESET_PASSWORD_REQUEST,
      payload: {
        email: formData.email,
        password: formData.password,
        otp: otp.join(''),
      },
    });
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '1rem',
      }}
    >
      <div
        className="card shadow-lg"
        style={{
          maxWidth: 420,
          width: '100%',
          borderRadius: '1rem',
          padding: '2rem',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        <h2 className="card-title text-center mb-4 fw-bold" style={{ color: '#333' }}>
          Reset Password
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="form-label fw-semibold">
              Email Address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-control"
              placeholder="your.email@example.com"
              value={formData.email}
              onChange={handleChange}
              required
              readOnly // Make field non-editable
              ref={emailRef}
            />
          </div>

          <div className="mb-4 position-relative">
            <label htmlFor="password" className="form-label fw-semibold">
              New Password
            </label>
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              placeholder="Enter new password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span
              onClick={() => setShowPassword(prev => !prev)}
              style={{
                position: 'absolute',
                top: '42px',
                right: '12px',
                cursor: 'pointer',
                color: '#666',
                userSelect: 'none',
              }}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') setShowPassword(prev => !prev);
              }}
            >
              {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
            </span>
          </div>

          <div className="mb-4 position-relative">
            <label htmlFor="confirmPassword" className="form-label fw-semibold">
              Confirm Password
            </label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type={showConfirmPassword ? 'text' : 'password'}
              className="form-control"
              placeholder="Confirm new password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <span
              onClick={() => setShowConfirmPassword(prev => !prev)}
              style={{
                position: 'absolute',
                top: '42px',
                right: '12px',
                cursor: 'pointer',
                color: '#666',
                userSelect: 'none',
              }}
              aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') setShowConfirmPassword(prev => !prev);
              }}
            >
              {showConfirmPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
            </span>
          </div>

          {(error || localError) && (
            <div className="alert alert-danger py-2 mb-4 text-center" style={{ fontWeight: '500', fontSize: '0.9rem' }}>
              {error || localError}
            </div>
          )}

          <button
            type="submit"
            className="btn w-100 py-2 fw-bold"
            disabled={loading}
            style={{
              fontSize: '1.1rem',
              borderRadius: '0.75rem',
              letterSpacing: '0.05em',
              backgroundColor: '#000',
              color: '#fff',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.4)',
              transition: 'background-color 0.3s ease',
              border: 'none',
            }}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
        <div className="mt-4 text-center">
          <button
            className="btn btn-link text-decoration-none"
            onClick={onBackToLogin}
            type="button"
            style={{ fontWeight: '600', color: '#764ba2' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
